/* Auth */
export const LOGIN_SUCCESS = "AUTH/LOGIN_SUCCESS";
export const LOGIN_FAILURE = "AUTH/LOGIN_FAILURE";
export const LOGIN_ACCOUNT_LOCKED = "AUTH/LOGIN_ACCOUNT_LOCKED";
export const SIGNUP_SUCCESS = "AUTH/SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "AUTH/SIGNUP_FAILURE";
export const RESET_PASSWORD_SUCCESS = "AUTH/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "AUTH/RESET_PASSWORD_FAILURE";
export const UPDATE_PASSWORD_SUCCESS = "AUTH/UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "AUTH/UPDATE_PASSWORD_FAILURE";
export const WHITE_LABEL_SIGNUP_SUCCESS = "AUTH/WHITE_LABEL_SIGNUP_SUCCESS";
export const WHITE_LABEL_SIGNUP_FAILURE = "AUTH/WHITE_LABEL_SIGNUP_FAILURE";

/* User */
export const USER_STATUS_CHANGED_SUCCESS = "USER/USER_STATUS_CHANGED_SUCCESS";
export const USER_STATUS_CHANGED_FAILURE = "USER/USER_STATUS_CHANGED_FAILURE";
/* User */

/* Saq */
export const FETCH_QUESTIONS_SAQ_A = "SAQ_A/FETCH_QUESTIONS";
/* Saq */

/* Completed SAQs */
export const FIND_COMPLETED_SAQ_LIST_SUCCESS =
  "COMPLETED_SAQ/FIND_COMPLETED_SAQ_LIST_SUCCESS";
export const FIND_COMPLETED_SAQ_LIST_ERROR =
  "COMPLETED_SAQ/FIND_COMPLETED_SAQ_LIST_ERROR";
/* Completed SAQs */

/* SAQ */
/* Completed SAQs */
export const SAQ_CREATE_SUCCESS = "SAQ/SAQ_CREATE_SUCCESS";
export const SAQ_CREATE_ERROR = "SAQ/SAQ_CREATE_ERROR";

export const SAQ_DELETE_SUCCESS = "SAQ_DELETE_SUCCESS";
export const SAQ_DELETE_ERROR = "SAQ_DELETE_ERROR";
/* SAQ */

/* White Label */
export const WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS =
  "WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS";
export const WHITE_LABEL_BUSINESS_USER_FETCH_ERROR =
  "WHITE_LABEL_BUSINESS_USER_FETCH_ERROR";
export const BUSINESS_USER_FETCH_SUCCESS =
  "BUSINESS/BUSINESS_USER_FETCH_SUCCESS";
export const BUSINESS_USER_FETCH_ERROR = "BUSINESS/BUSINESS_USER_FETCH_ERROR";
export const BUSINESS_STATUS_UPDATE_SUCCESS =
  "BUSINESS/BUSINESS_STATUS_UPDATE_SUCCESS";
export const BUSINESS_STATUS_UPDATE_ERROR =
  "BUSINESS/BUSINESS_STATUS_UPDATE_ERROR";
/* White Label */
